(function(global){
  'use strict';
  class BoundedRefresh {
    constructor({delays=[3000,8000,15000,30000],limit=90000,clock=()=>Date.now(),setTimer=(fn,ms)=>setTimeout(fn,ms),clearTimer=id=>clearTimeout(id)}={}){
      Object.assign(this,{delays,limit,clock,setTimer,clearTimer});this.key=null;this.run=null;
    }
    cancel(){if(this.run){this.run.controller.abort();this.clearTimer(this.run.timer);this.clearTimer(this.run.expiry);}this.run=null;this.key=null;}
    ensure(key,step,finished=()=>{}){
      if(this.key===key)return;
      this.cancel();this.key=key;
      const run={controller:new AbortController(),started:this.clock(),index:0};this.run=run;
      run.expiry=this.setTimer(()=>{run.controller.abort();this.clearTimer(run.timer);finished('expired');},this.limit);
      const schedule=()=>{
        if(this.run!==run||run.controller.signal.aborted)return;
        if(run.index>=this.delays.length){this.clearTimer(run.expiry);finished('exhausted');return;}
        run.timer=this.setTimer(async()=>{
          if(this.run!==run||run.controller.signal.aborted)return;
          let again=true;
          try{again=await step(run.index++,run.controller.signal)!==false;}catch{}
          if(again)schedule();else{this.clearTimer(run.expiry);finished('complete');}
        },this.delays[run.index]);
      };schedule();
    }
  }
  global.TruckFitmentRefresh={BoundedRefresh};
  if(typeof module!=='undefined')module.exports={BoundedRefresh};
})(typeof window!=='undefined'?window:globalThis);
